export enum WidgetEvent {
  EmailPrechecked = 'EmailPrechecked',
  EmailPrecheckLogin = 'EmailPrecheckLogin',
  EmailVerificationCodeSent = 'EmailVerificationCodeSent',
  EmailVerificationCodeReSent = 'EmailVerificationCodeReSent',
  EmailVerificationStatus = 'EmailVerificationStatus',
  EmailVerificationBack = 'EmailVerificationBack',
  SMSVerificationBypass = 'SMSVerificationBypass',
  SMSVerification = 'SMSVerification',
  SMSVerificationBack = 'SMSVerificationBack',
  AddDifferentPhoneNumberOpened = 'AddDifferentPhoneNumberOpened',
  SMSVerificationCodeSent = 'SMSVerificationCodeSent',
  SMSVerificationCodeReSent = 'SMSVerificationCodeReSent',
  SMSVerificationStatus = 'SMSVerificationStatus',
  ProcessFinished = 'ProcessFinished',
  TechnicalError = 'TechnicalError',
  DAPStatusReport = 'DAPStatusReport',
  LoginClicked = 'LoginClicked',
}
